<template>
    <nav class="navbar navbar-expand navbar-theme ps-0 pt-2">
        <a class="sidebar-toggle d-flex me-3"
            @click="(()=> { $store.state.menuToggled = !$store.state.menuToggled })"
        >
            <i class="hamburger align-self-center"></i>
        </a>
        <div class="w-100">
            <!-- 設定臨時公告 -->
            <div v-if="bulletin.length > 0"
                class="alert alert-warning alert-dismissible bulletin-view" 
                role="alert"
            >
                <i class="align-middle me-1 fas fa-fw fa-bullhorn"></i>
                <marquee class="alert-message">
                    <h3 class="text-white"><strong>[公告]</strong> {{ bulletin[0].bulletin_content }}</h3>
                </marquee>
            </div>
        </div>
    </nav>
</template>
  
<script>

export default {
    name: 'navBar',
    data(){
        return {
            bulletin:[],
            bulletinUpdateInterval:null
        }
    },
    async created(){
        await this.updateBulletin();
        this.startBulletinUpdate();
    },
    methods: {
        async updateBulletin() {
            const res = await this.$api.getBulletinListAPI();
            if (res.code == 200) {
                this.bulletin[0] = (res.data);
                console.log(this.bulletin)
            }
        },
        startBulletinUpdate() {
            // 每隔一個小時（3600000 毫秒）更新公告
            this.bulletinUpdateInterval = setInterval(async () => {
                await this.updateBulletin();
            }, 3600000);
        }
    },
    unmounted(){
        // 清除定時器，防止內存洩漏
        if (this.bulletinUpdateInterval) {
            clearInterval(this.bulletinUpdateInterval);
        }
    },
    beforeDestroy() {
        // 清除定時器，防止內存洩漏
        if (this.bulletinUpdateInterval) {
            clearInterval(this.bulletinUpdateInterval);
        }
    }
};
</script>
<style scoped>
.bulletin-view{
    padding: 0px .725rem;
    display: flex;
    align-items: center;
}
</style>